import {
  BUSINESSES_ALL_FAILURE,
  BUSINESSES_ALL_REQUEST,
  BUSINESSES_ALL_SUCCESS,
  BUSINESS_BY_NAME_REQUEST,
  BUSINESS_BY_NAME_SUCCESS,
  BUSINESS_BY_NAME_FAILURE,
} from '../actions/businesses_all'

export function businessesAll(
  state = {
    isFetching: false,
    businesses: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESSES_ALL_REQUEST:
      return {
        ...state,
        businesses: null,
        isFetching: true,
        errorMessage: null,
      }
    case BUSINESS_BY_NAME_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case BUSINESSES_ALL_SUCCESS:
    case BUSINESS_BY_NAME_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        businesses: action.response.results,
      }
    case BUSINESSES_ALL_FAILURE:
    case BUSINESS_BY_NAME_FAILURE:
      return {
        ...state,
        businesses: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
